import type { CSSProperties } from 'react';

import classNames from '../../../utils/classNames';
import Orb from '../../atoms/Orb';

import './index.css';

interface SupportAvatarProps {
  className?: string;
  hue?: number;
  hoverIntensity?: number;
  rotateOnHover?: boolean;
  forceHoverState?: boolean;
  ariaLabel?: string;
  style?: CSSProperties;
  size?: string | null;
}

export default function SupportAvatar({
  className,
  hue = 0,
  hoverIntensity = 0.3,
  rotateOnHover = false,
  forceHoverState = true,
  ariaLabel,
  style,
  size = '48px',
}: SupportAvatarProps) {
  const role = ariaLabel ? 'img' : 'presentation';
  const computedStyle: CSSProperties = {
    ...style,
  };

  if (size != null) {
    computedStyle.width = size;
    computedStyle.height = size;
  }

  return (
    <div
      className={classNames('support-avatar', className)}
      role={role}
      aria-label={ariaLabel}
      style={computedStyle}
    >
      <Orb
        hue={hue}
        hoverIntensity={hoverIntensity}
        rotateOnHover={rotateOnHover}
        forceHoverState={forceHoverState}
      />
    </div>
  );
}
